import { environment } from './../../../environments/environment';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { RegistryFirebaseService } from './../../registry/registry-firebase.service';
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';
import { Injectable } from '@angular/core';
import { Upload } from './upload';
import * as firebase from 'firebase';
import { Observable } from 'rxjs/Observable';
import { Gift } from '../../gift/gift';
@Injectable()
export class UploadService {

  cdnHost = environment.imgCdnHost;
  basePath = 'uploads';
  uploads: Observable<Upload[]>;
  private imageUrlSource = new BehaviorSubject<string>(null);

  public uploadedImageObservable: Observable<string> = this.imageUrlSource.asObservable();


  giftsCollectionRef: AngularFirestoreCollection<Gift>;
  constructor(private afs: AngularFirestore,
    private registryFirebaseService: RegistryFirebaseService) {

  }

  getUploads() {

  }



  pushUploadBase64(base64:string){
    


  let  uploadTask = this.afs.app.storage().ref('/cropped/').child('d222sfsdfds')
  .putString(base64.substring(23), 'base64', {contentType:'image/jpg'});
uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
  (snapshot: firebase.storage.UploadTaskSnapshot) => {
    // upload in progress
    const snap = snapshot;
    switch (snapshot.state) {
      case firebase.storage.TaskState.PAUSED: // or 'paused'
        console.log('Upload is paused');
        break;
      case firebase.storage.TaskState.RUNNING: // or 'running'
        console.log('Upload is running');
        break;
    }

  },
  (error) => {
    // upload failed
  console.log(error);
  },
  () => {
    
    // upload success
    console.log(uploadTask.snapshot.downloadURL);

});


  }
  pushUpload(upload: Upload, isFont = false ) {

    if (!upload) {
      this.imageUrlSource.next(null);
      return;
    }
    const tempId = this.afs.createId();
    let test = upload.file.name.split('.');
    ;
    let filename = tempId + '.' + test[test.length - 1];
    if (isFont){
        filename = tempId+"__z__"+ test[0] + '.' + test[test.length - 1];
    }


    
    const storageRef = this.afs.app.storage().ref();
    const uploadTask = storageRef.child(`${this.basePath}/${filename}`).put(upload.file);

    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
      (snapshot: firebase.storage.UploadTaskSnapshot) => {
        // upload in progress
        const snap = snapshot;
        upload.progress = Math.round((snap.bytesTransferred / snap.totalBytes) * 100);
      },
      (error) => {
        // upload failed
        return Observable.create(false);
      },
      () => {
        // upload success
        upload.url = uploadTask.snapshot.downloadURL;
        upload.url = this.cdnHost + filename;
        upload.name = filename;
        const body = document.getElementsByTagName('body')[0];
        body.style.overflow = "auto";


        this.imageUrlSource.next(upload.url);


        return upload;
      },
    );
  }

  // Writes the file details to the realtime db
  private saveFileData(upload: Upload) {
    // 1 - Copy.PNG

    upload.url = this.cdnHost + upload.file.name;

  }


  //  this.db.list(`${this.basePath}/`).push(upload);


  // // Writes the file details to the realtime db
  // private deleteFileData(key: string) {
  //
  //   return this.db.list(`${this.basePath}/`).remove(key);
  // }

  // // Firebase files must have unique names in their respective storage dir
  // // So the name serves as a unique key
  // private deleteFileStorage(name: string) {
  //
  //   const storageRef = firebase.storage().ref();
  //   storageRef.child(`${this.basePath}/${name}`).delete()
  // }
}



// WEBPACK FOOTER //
// ./src/app/uploads/shared/upload.service.ts